import instance from '@/http';

export default {
	getList() {
		return instance().get("/billings").then(resp => resp).catch(error => error);
	},
	getPPWFilesList(id) {
		return instance().get(`/billings/${ id }`).then(resp => resp).catch(error => error);
	},
	getBillingsFilter(data) {
		return instance().post(`/billings/list`, data).then(resp => resp).catch(error => error);
	},
};
